// i18n area 'tasks' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.uk-UA.meta.json.
import type { enUS } from './tasks'

export const ukUA: typeof enUS = {
  macrotasks: {
    title: 'Макрозавдання',
    subtitle: 'Складені операції — можна відновити з невдалого кроку або перервати',
    colType: 'Тип',
    colTarget: 'Об’єкт',
    colPhase: 'Фаза',
    colSteps: 'Кроки',
    empty: 'Макрозавдань немає',
    detail: 'Деталі',
    failedAt: 'помилка на кроці',
    resume: 'Повторити з невдалого кроку',
    abort: 'Перервати все',
    cancel: 'Скасувати',
    actionError: 'Дію відхилено'
  },
  tasks: {
    title: 'Завдання',
    searchPlaceholder: 'Пошук за типом або ціллю',
    type: 'Тип',
    target: 'Ціль',
    phaseLabel: 'Фаза',
    progress: 'Прогрес',
    started: 'Початок',
    finished: 'Завершення',
    node: 'Вузол',
    empty: 'Завдань немає',
    loadError: 'Не вдалося завантажити завдання — чи доступний бекенд TVirt?',
    limboHint: 'Вузол «{node}» недоступний з {time} — завдання утримує оренду на запис для своєї цілі, доки вузол не повернеться або доки його не буде засвідчено вимкненим',
    nodeAttested: 'Вузол засвідчено вимкненим',
    phase: {
      queued: 'У черзі',
      running: 'Виконується',
      succeeded: 'Завершено',
      failed: 'Помилка',
      cancelled: 'Скасовано',
      'failed-at-step': 'Помилка на кроці',
      aborted: 'Перервано'
    },
    dropdown: {
      tooltip: 'Завдання в роботі',
      title: 'Завдання в роботі',
      empty: 'Немає завдань у роботі',
      viewAll: 'Переглянути всі завдання'
    },
    detail: {
      open: 'Деталі',
      scope: 'Скоуп',
      message: 'Повідомлення',
      params: 'Параметри',
      result: 'Результат',
      errorTitle: 'Помилка',
      steps: 'Кроки',
      failedAt: 'помилка на кроці',
      superseded: 'замінено',

      // Стандартний діалог (раунд #156): місце дочірнього завдання у плані
      // батьківського, саме батьківське завдання (відкривається на місці) і крок-винуватець.
      step: 'Крок',
      parent: 'Батьківське завдання',
      failedStep: 'Невдалий крок',
      log: 'Журнал',
      logEmpty: 'Записів журналу ще немає',
      close: 'Закрити'
    },
    actions: {
      cancel: 'Скасувати',
      resume: 'Повторити з невдалого кроку',
      abort: 'Перервати все (відкат виконаних кроків)',
      refused: 'Дію відхилено'
    }
  },
  events: {
    loadError: 'Не вдалося завантажити журнал — чи доступний бекенд TVirt?',
    title: 'Події',
    subtitle: "Історична пам'ять кластера: доконані факти, від найновіших",
    filterSeverity: 'Важливість',
    filterCategory: 'Категорія',
    filterAll: 'Усі',
    searchLabel: 'Пошук',
    searchPlaceholder: 'Шукати в усьому журналі',
    subjectFilter: 'Події {subject} — показати всі',
    colAt: 'Коли',
    colSeverity: 'Важливість',
    colType: 'Тип',
    colSubject: "Об'єкт",
    colActor: 'Хто',
    colNode: 'Node',
    colMessage: 'Повідомлення',
    empty: 'Подій немає',
    loadMore: 'Завантажити ще',
    actorSystem: 'система',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID події',
    taskCollectedHint: 'Task має коротше зберігання: після збирання посилання більше не відповідає',
    severity: {
      info: 'Інформація',
      warning: 'Попередження',
      error: 'Помилка',
      critical: 'Критично'
    },
    category: {
      lifecycle: 'Життєвий цикл',
      config: 'Конфігурація',
      availability: 'Доступність',
      security: 'Безпека'
    },
    type: {
      haNetsvcFailedOver: 'Аварійне перемикання мережевої служби',
      haNetsvcNoCandidate: 'Мережева служба без вузла-кандидата',
      haNetsvcReaped: 'Локальний екземпляр пожатий при поверненні',
      netsvcFloatipMoved: 'Плаваюча IP перейшла до іншого власника',
      netsvcFloatipNoHolder: 'Плаваюча IP без здорової цілі',
      haAppFailedOver: 'Failover екземпляра App',
      haAppNoCandidate: 'Екземпляр App без вузла-кандидата',
      haAppStorageLocalSkip: 'Екземпляр App не перенесено: постійні дані локальні для мертвого вузла',
      haAppReaped: 'Локальний под екземпляра App зібрано при поверненні'
    }
  },
  audit: {
    loadError: 'Не вдалося завантажити журнал аудиту — чи доступний бекенд TVirt?',
    title: 'Аудит',
    subtitle: "Хто що зробив, коли та над яким об'єктом — спроби дій, включно з відмовами",
    filterOutcome: 'Підсумок',
    filterAll: 'Усі',
    filterSudo: 'Лише дії з підвищенням прав',
    colAt: 'Коли',
    colActor: 'Хто',
    colAction: 'Дія',
    colTarget: "Об'єкт",
    colOutcome: 'Підсумок',
    colNode: 'Node',
    empty: 'Дій не записано',
    loadMore: 'Завантажити ще',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Маршрут',
    detailProblem: 'Причина',
    detailTask: 'Task',
    detailClientIp: 'Звідки',
    detailId: 'ID запису',
    detailSession: 'Сеанс',
    taskHint: 'Підсумок прийнятої дії живе в журналі подій, під тим самим id task',
    outcome: {
      succeeded: 'Виконано',
      accepted: 'Прийнято',
      denied: 'Відмовлено',
      rejected: 'Відхилено',
      failed: 'Збій'
    }
  },
  notifications: {
    loadError: 'Не вдалося завантажити сповіщення — чи доступний бекенд TVirt?',
    actionError: 'Дію відхилено',
    title: 'Сповіщення',
    subtitle: 'Призначення, до яких факти журналу залишають кластер',
    rulesTitle: 'Правила',
    rulesSubtitle: 'Які факти виходять і куди',
    deliveriesTitle: 'Доставки',
    deliveriesSubtitle: 'Результат кожного сповіщення з причиною, коли воно не вдається',
    colName: 'Назва',
    colKind: 'Тип',
    colWhere: 'Куди',
    colScope: 'Scope',
    colSeverity: 'Важливість',
    colMatch: 'Фільтр',
    colTargets: 'Призначення',
    colAt: 'Коли',
    colState: 'Стан',
    colEvent: 'Подія',
    colAttempts: 'Спроби',
    colOutcome: 'Результат',
    empty: 'Немає рядків',
    matchAll: 'усі факти',
    test: 'Перевірити',
    testOk: 'Тестове сповіщення доставлено до {target}',
    testFailed: 'Перевірка до {target} не вдалася: {reason}',
    retry: 'Повернути в чергу',
    retried: 'Доставку повернуто в чергу',
    grouped: 'і ще {count} повторень',
    state: {
      failed: 'Не доставлено',
      pending: 'У черзі',
      sending: 'Надсилається',
      sent: 'Надіслано'
    },
    tabTargets: 'Призначення',
    tabRules: 'Правила',
    tabDeliveries: 'Доставки',
    targetCreateTitle: 'Нове призначення',
    ruleCreateTitle: 'Нове правило',
    nameHint: 'Малі літери, цифри та дефіси; унікально в межах області',
    kindImmutableHint: 'Незмінне: зміна типу означає створення іншого призначення',
    kindSmtp: 'Пошта (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Стан',
    enabledOn: 'Активне',
    enabledOff: 'Призупинене',
    smtpHost: 'SMTP-сервер',
    smtpPort: 'Порт',
    smtpPortHint: 'Зазвичай: 25 без TLS, 587 зі starttls, 465 з tls',
    smtpSecurity: 'Безпека',
    smtpFrom: 'Відправник',
    smtpTo: 'Отримувачі',
    smtpToHint: 'Одна або кілька адрес через кому',
    webhookUrl: 'URL',
    payload: 'Вміст',
    payloadHint: 'З minimal повідомлення та дані події не покидають кластер',
    credential: 'Облікові дані',
    credentialNone: 'Немає',
    credentialHintSmtp: 'Обліковий запис релею зі сховища ключів; немає означає анонімний SMTP',
    credentialHintWebhook: 'Секрет підпису зі сховища ключів; без підпису будь-хто, хто знає URL, може вдати кластер',
    minSeverityHint: 'Поріг, а не множина: від цієї важливості й вище',
    categories: 'Категорії',
    categoriesHint: 'Порожньо = всі',
    types: 'Типи подій',
    typesHint: 'Через кому; порожньо = всі. Невідомий тип відхиляється',
    targetsHint: 'Принаймні одне; вони мусять бути в області правила або в її предку',
    recursiveOn: 'Також дочірні області',
    recursiveOff: 'Лише ця область',
    recursiveHint: 'Ресурси живуть у листках: без нащадків правило на корені сповіщає майже ні про що',
    repeatWindow: 'Вікно групування (с)',
    repeatWindowHint: 'У межах вікна повтори не надсилають пошту: вони рахуються на першому. 0 вимикає',
    targetInUseError: 'Призначення {name} досі використовує правило'
  }
}
